module.exports = __webpack_public_path__ + "static/img/02.e1191a24.jpg";